import React from "react";

function Icon(data) {
    return (
        <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 176 248"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    width={data.w} height={data.h}
  >
    <path
      d="m184.94 162.45 14.67 29.1 19.72 39.13-32.38-7.62-13.14 30.56-19.72-39.13-14.67-29.1 45.52-22.94Z"
      style={{
        fill: "#fff",
        fillRule: "nonzero",
      }}
      transform="rotate(53.001 136.872 76.071)"
    />
    <path
      d="m121.19 268.99-16.49-38.35-40.64 9.56 43.59-86.48 57.13 28.79-43.59 86.48Zm-8.85-53.5 9.79 22.77 25.19-49.99-33.91-17.09-25.19 49.99 24.12-5.67v-.01Z"
      style={{
        fill: "#ef7c00",
        fillRule: "nonzero",
      }}
      transform="translate(-57.75 -21.1)"
    />
    <path
      d="m184.94 162.45 14.67 29.1 19.72 39.13-32.38-7.62-13.14 30.56-19.72-39.13-14.67-29.1 45.52-22.94Z"
      style={{
        fill: "#fff",
        fillRule: "nonzero",
      }}
      transform="translate(-57.75 -21.1)"
    />
    <path
      d="m174.27 268.99-43.59-86.48 57.13-28.79 43.59 86.48-40.64-9.56-16.49 38.35Zm-26.13-80.72 25.2 49.99 9.79-22.77 24.12 5.67-25.2-49.99-33.91 17.09v.01Z"
      style={{
        fill: "#ef7c00",
        fillRule: "nonzero",
      }}
      transform="translate(-57.75 -21.1)"
    />
    <circle
      cx={145.73}
      cy={109.08}
      r={79.48}
      style={{
        fill: "#fff",
      }}
      transform="translate(-57.75 -21.1)"
    />
    <path
      d="M145.73 197.06c-48.51 0-87.98-39.47-87.98-87.98 0-48.51 39.47-87.98 87.98-87.98 48.51 0 87.98 39.47 87.98 87.98 0 48.51-39.47 87.98-87.98 87.98Zm0-158.96c-39.14 0-70.98 31.84-70.98 70.98s31.84 70.98 70.98 70.98 70.98-31.84 70.98-70.98-31.84-70.98-70.98-70.98Z"
      style={{
        fill: "#3d3833",
        fillRule: "nonzero",
      }}
      transform="translate(-57.75 -21.1)"
    />
    <path
      d="M118.74 74c7.41 0 12.99 1.81 16.73 5.42s5.61 8.46 5.61 14.56c0 3.28-.69 6.52-2.05 9.74-1.37 3.21-3.26 6.27-5.66 9.19-2.4 2.91-5.23 5.6-8.47 8.08-3.24 2.48-6.7 4.58-10.37 6.32h28.05v13.53H97.29v-12.93c3.87-3.01 7.48-5.88 10.82-8.62 3.34-2.74 6.25-5.39 8.72-7.97 2.47-2.57 4.41-5.09 5.81-7.56 1.4-2.47 2.1-4.94 2.1-7.41 0-5.14-2.77-7.71-8.32-7.71-3.41 0-6.53.64-9.37 1.9-2.84 1.27-5.33 2.77-7.46 4.51-.94-1.14-1.72-2.37-2.35-3.71a9.428 9.428 0 0 1-.95-4.11c0-2.14.55-4.02 1.65-5.66 1.1-1.64 2.64-3.02 4.61-4.16 1.97-1.14 4.32-1.99 7.06-2.56 2.74-.57 5.78-.85 9.12-.85h.01ZM172.34 73.9c8.08 0 14.34 2.66 18.79 7.97 4.44 5.31 6.66 13.58 6.66 24.8s-2.25 20.17-6.76 26.25c-4.51 6.08-10.91 9.12-19.19 9.12-9.08 0-15.77-2.74-20.04-8.22-4.28-5.48-6.41-13.93-6.41-25.35 0-11.42 2.39-19.87 7.16-25.75 4.78-5.88 11.37-8.82 19.79-8.82Zm-.3 13.53c-3.47 0-6.05 1.74-7.71 5.22-1.67 3.48-2.5 8.64-2.5 15.47 0 7.3.88 12.52 2.66 15.67 1.77 3.15 4.22 4.72 7.36 4.72 2.94 0 5.28-1.74 7.01-5.22 1.74-3.48 2.6-8.8 2.6-15.97s-.84-12.1-2.5-15.22c-1.67-3.11-3.97-4.67-6.91-4.67h-.01Z"
      style={{
        fill: "#3d3833",
        fillRule: "nonzero",
      }}
      transform="translate(-57.75 -21.1)"
    />
  </svg>
    );
  }

export default Icon;
